import Section from '../../../../mixins/Section'
import * as d3 from 'd3-selection'
import { easeBackOut } from 'd3-ease'
import 'd3-transition'
export default {
  mixins: [Section],
  name: 'LegalsView',
  data () {
    return {
      i18nGroupName: 'legals'
    }
  },
  mounted () {
    this.$nextTick(this.show)
  },
  methods: {
    enter () {
    },
    leave (el, done) {
      d3.select('.legals-container')
        .selectAll('p')
        .transition()
        .duration(200)
        .style('opacity', '0')
    },
    show () {
      const el = d3.select('.legals-container').selectAll('p')
      if (el.size() > 0) {
        el.transition()
          .ease(easeBackOut)
          .duration(400)
          .delay((d, i) => i * 40)
          .style('opacity', '1')
      } else {
        setTimeout(this.show, 20)
      }
    }
  }
}
